/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSDocumentType {
    GENERAL_DOC = <any> 'GENERAL_DOC',
    SCHADEN_DOC = <any> 'SCHADEN_DOC',
    VORLEISTUNG_DOC = <any> 'VORLEISTUNG_DOC',
    FREMDKOSTEN_DOC = <any> 'FREMDKOSTEN_DOC',
    ANLAUFSTELLE_DOC = <any> 'ANLAUFSTELLE_DOC',
    VERSICHERUNGSBEITRAG_DOC = <any> 'VERSICHERUNGSBEITRAG_DOC',
    GESUCHSTELLER_DOC = <any> 'GESUCHSTELLER_DOC',
    ZWEITPERSON_DOC = <any> 'ZWEITPERSON_DOC',
    TMP_DECKBLATT = <any> 'TMP_DECKBLATT',
    FONDSSUISSE_DOC = <any>'FONDSSUISSE_DOC',
    AUFWAENDE_DOC = <any>'AUFWAENDE_DOC',
    SCHAETZUNG_DOC = <any>'SCHAETZUNG_DOC',
    EIGENLEISTUNG_DOC = <any>'EIGENLEISTUNG_DOC',
}

export function getDocumentTypes(): Array<TSDocumentType> {
    return [
        TSDocumentType.GENERAL_DOC,
        TSDocumentType.SCHADEN_DOC,
        TSDocumentType.VORLEISTUNG_DOC,
        TSDocumentType.FREMDKOSTEN_DOC,
        TSDocumentType.ANLAUFSTELLE_DOC,
        TSDocumentType.VERSICHERUNGSBEITRAG_DOC,
        TSDocumentType.GESUCHSTELLER_DOC,
        TSDocumentType.ZWEITPERSON_DOC,
        TSDocumentType.TMP_DECKBLATT,
        TSDocumentType.FONDSSUISSE_DOC,
        TSDocumentType.AUFWAENDE_DOC,
        TSDocumentType.SCHAETZUNG_DOC,
        TSDocumentType.EIGENLEISTUNG_DOC,
    ];
}





// WEBPACK FOOTER //
// ./src/app/models/enums/TSDokumentType.ts